import React from "react";
import { motion } from "framer-motion";
import Footer from "./components/Footer";
import "../css/FAQs.css";

function FAQs() {
  const faqs = [
    {
      question: "How long does shipping take?",
      answer: "Shipping usually takes 5-10 business days within the UK."
    },
    {
      question: "What is your return policy?",
      answer: "Unfortunately, as we are a small business, we cannot offer returns at this time. However, for any queries please contact us at couscouscollective@outlook.com and we will be more than happy to help you out."
    },
    {
      question: "Do you ship internationally?",
      answer: "Currently, we only ship within the UK. We hope to offer international shipping in the future."
    },
    {
      question: "Do you offer custom prints/sizes?",
      answer: "If you would like a custom print or size, get in contact with us and we'd be happy to discuss this with you!"
    },
    {
      question: "I also make art, can we collaborate?",
      answer: "CousCousCollective is built to be a platform for people to share their creative work - we very much welcome any collaboration requests!"
    },
  ];

  // FAQ item animation
  const itemVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: { delay: i * 0.1 + 0.3, duration: 0.5, ease: "easeOut" }
    })
  };

  return (
    <motion.div
      className="faqs-container"
      initial={{ y: 100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: 100, opacity: 0 }}
      transition={{ duration: 0.7, ease: "easeOut" }}
    >
      <div className="faqs-list frosted">
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
        >
          FAQs
        </motion.h1>

        {faqs.map((faq, i) => (
          <motion.div
            key={i}
            className="faq-item"
            custom={i}
            variants={itemVariants}
            initial="hidden"
            animate="visible"
          >
            <h3 className="faq-question">{faq.question}</h3>
            <p className="faq-answer">{faq.answer}</p>
          </motion.div>
        ))}
      </div>

      <Footer />
    </motion.div>
  );
}

export default FAQs;